/**
 * Read an image File, downscale to fit within `maxDim` on the longest side
 * (preserving aspect ratio), and return a base64 JPEG data URL.
 * Falls back to the raw base64 if anything fails.
 */
export async function readAndDownscaleImage(file, maxDim = 1600, quality = 0.85) {
  const rawDataUrl = await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  try {
    const img = await new Promise((resolve, reject) => {
      const i = new Image();
      i.onload = () => resolve(i);
      i.onerror = reject;
      i.src = rawDataUrl;
    });
    const longest = Math.max(img.width, img.height);
    if (longest <= maxDim) return rawDataUrl;
    const scale = maxDim / longest;
    const w = Math.round(img.width * scale);
    const h = Math.round(img.height * scale);
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0, 0, w, h);
    return canvas.toDataURL("image/jpeg", quality);
  } catch (e) {
    return rawDataUrl;
  }
}

export const PHOTO_MAX_BYTES = 8 * 1024 * 1024; // 8 MB
